import type { FormxKpiValueItem, IFormxRepository } from '../repositories/IFormxRepository.js';

interface Deps { formxRepository: IFormxRepository; }

export function createListFormxKpiValuesByProjectUseCase({ formxRepository }: Deps) {
  return async function listFormxKpiValuesByProject(projectId: string): Promise<FormxKpiValueItem[]> {
    return formxRepository.listKpiValuesByProject(projectId);
  };
}
